export var environment = {
    production: false,
    ambiente: window._env.ambiente,
    ambi_tipo_id: window._env.ambi_tipo_id,
    pluriConnect: {
        back: window._env.pluriConnect.back,
        front: window._env.pluriConnect.front
    },
    builds: {
        back: window._env.builds.back
    }
};
